import React from 'react';

const Error = (props: any) => {
	return (
		<span style={{color: 'red'}} className='error'>{props.Text}</span>
	);
}

export default Error;